var map = {
	"./audio/c.bqn": 39923,
	"./audio/zelda.bqn": 75667,
	"./fizzbuzz.bqn": 42646,
	"./graphics/circle.bqn": 93808,
	"./graphics/mandelbrot.bqn": 71057,
	"./longestLine.bqn": 91249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38746;